import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../common/types';
import { SMLThemeSwitch } from '../../music24/components/SMLThemeSwitch';
import { Music24FullLogo } from '../../music24/components/Music24FullLogo';
import { useUserToken, useUserTokenDecoded } from '../../../redux/slices/appInfo/hooks';
import { useOnLogout } from '../../../redux/slices/appInfo/useOnLogout';
import { LanguagePicker } from '../../app/locale/LanguagePicker';
import { welcomeMessages as messages } from './welcomeMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole welcome page; each part uses its own slice of it */
import styles from './WelcomeView.module.scss';
/* eslint-enable css-modules/no-unused-class */

/**
 * The brand, the email, "Sign out", the language and the theme (design: onboarding a1 and a8,
 * `.ob-top`). The page has no sidebar. The language picker saves to the account (QA lit-1).
 */
const WelcomeTopBarComponent: React.FC = () => {
  const intl = useIntl();
  const userToken = useUserToken();
  const email = useUserTokenDecoded()?.email ?? '';
  const signOut = useOnLogout(userToken);

  return (
    <header className={styles.top}>
      <span className={styles.brand}>
        <Music24FullLogo size={26} />
      </span>
      <div className={styles.who}>
        {email !== '' ? <span className={styles.whoEmail}>{email}</span> : null}
        <button type="button" className={styles.link} onClick={signOut}>
          {intl.formatMessage(messages.signOut)}
        </button>
        <LanguagePicker mode="account" />
        <SMLThemeSwitch variant="icon" direction="down" align="end" />
      </div>
    </header>
  );
};

export const WelcomeTopBar = TypedMemo(WelcomeTopBarComponent);
